export function buildAlert(type, message, options = {}) {
    return {
        type, // success | danger | warning | info
        message,
        title: options.title || '',
        details: Array.isArray(options.details) ? options.details : [],
        dismissible: options.dismissible !== false,
        autoHideMs: options.autoHideMs || 0,
    };
}

export function buildSuccessAlert(message, options = {}) {
    return buildAlert('success', message, options);
}

export function buildErrorAlert(message, options = {}) {
    return buildAlert('danger', message, options);
}

export function buildWarningAlert(message, options = {}) {
    return buildAlert('warning', message, options);
}

export function buildInfoAlert(message, options = {}) {
    return buildAlert('info', message, options);
}

export function getApiErrorMessage(error, fallback = 'Operation failed') {
    return (
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        fallback
    );
}

/**
 * 把多个参数拼成一条消息
 * 用法：
 * formatAlertMessage('保存成功：{name}，语言：{lang}', { name: 'Bin', lang: 'es' })
 */
export function formatAlertMessage(template, params = {}) {
    if (!template) return '';
    return template.replace(/\{(\w+)\}/g, (_, key) => {
        const value = params[key];
        return value === undefined || value === null ? '' : String(value);
    });
}

/**
 * 用于跳转到别的页面后显示 alert
 * navigate('/users', { state: { alert: buildSuccessAlert('保存成功') } })
 */
export function getRouteAlert(location) {
    return location?.state?.alert || null;
}